//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import Index from './components/Index.vue';
export default {
  components: {
    Index: Index
  },
  computed: {
    isPad: function isPad() {
      return env.isIpad || env.isApad;
    },
    now: function now() {
      return this.$store.state.now;
    }
  },
  methods: {},
  mounted: function mounted() {}
};